var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.38867,
    cy: 9.49902,
    r: 9,
    fill: "#1D1D39"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9 14L5 13.1L8.6 9.5L5 5.9L5.9 5L9.5 8.6L13.1 5L14 5.9L10.4 9.5L14 13.1L13.1 14L9.5 10.4L5.9 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeClose);
export default __webpack_public_path__ + "static/media/icone-close.c458879a1244c9d8a94a0504a116e061.svg";
export { ForwardRef as ReactComponent };